module.exports = __webpack_public_path__ + "media/חוף.3602b811.mp3";